<div height-100 flex flex-column class="ion-justify-content-between">
  <div>
    <div class="ion-margin">
      <ion-list
        max-width-form-web
        margin-auto
        class="ion-no-padding ion-align-items-center ion-justify-content-center styleCard"
      >
        <ion-item detail="false">
          <ion-grid>
            <ion-row>
              <ion-col size="11">
                <h2 light class="ion-no-margin text-primary-dark" no-padding>
                  {{ 'COMPONENTS.KEYS' | translate }}
                </h2>
              </ion-col>

              <ion-col size="1">
                <h2 light class="ion-no-margin text-primary-dark" no-padding>
                  {{ amountKeys }}
                </h2>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
        <ion-item detail="false" lines="none">
          <ion-grid>
            <ion-row>
              <ion-col size="11">
                <h2 light class="ion-no-margin text-primary-dark" no-padding>
                  {{ 'COMPONENTS.CONTROLS' | translate }}
                </h2>
              </ion-col>

              <ion-col size="1">
                <h2 light class="ion-no-margin text-primary-dark" no-padding>
                  {{ amountControls }}
                </h2>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </ion-list>

      <ion-col size="12">
        <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.STATE' | translate }}</h4>
        <h4 regular class="text-primary-dark ion-no-margin">
          {{
            conservationState != ''
              ? conservationState
              : ('COMPONENTS.NO_STATE_DESCRIPTION_ENTERED' | translate)
          }}
        </h4>
      </ion-col>

      <div class="divider-dark"></div>

      <ion-grid class="ion-padding">
        <ion-row *ngIf="photos.length > 0; else NoPhotos">
          <ion-col size="12">
            <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.PHOTOS' | translate }}</h4>
            <app-photo-gallery
              [canLoad]="false"
              [showButton]="false"
              [canRemove]="false"
              [styleInput]="{ 'padding-left': 0 }"
              [photoArray]="photos"
              [componentId]="this.evaluationSurveyElementItemId"
            ></app-photo-gallery>
          </ion-col>
        </ion-row>
      </ion-grid>
      <div class="divider"></div>
    </div>
  </div>
</div>

<ng-template #NoPhotos>
  <h4 text-center regular class="text-primary-dark-50 ion-no-margin">{{
    'COMPONENTS.THERE_ARE_NO_PHOTOS' | translate
  }}</h4>
</ng-template>
